import React from "react";
import { IoIosArrowForward } from "react-icons/io";
function BookingDatas({ bookingData, filtered, active }) {
  const Filter = (options) => {
    return options.filter((val, i) => {
      return (
        val["status"]?.toLowerCase().indexOf(filtered?.toLowerCase()) > -1 ||
        val["price"]?.toLowerCase().indexOf(filtered?.toLowerCase()) > -1 ||
        val["booking_number"]?.toLowerCase().indexOf(filtered?.toLowerCase()) >
          -1
      );
    });
  };

  return (
    <div>
      <div className="my-3  h-64  overflow-y-auto  scroll ">
        {Filter(bookingData).map((val, i) => {
          return active === val.status ? (
            <div className="bg-white rounded-md  my-4  px-5 py-2" key={i}>
              <div className="flex justify-between">
                <div className="  text-yellow-500 font-bold text-lg" key={i}>
                  #{val.token}
                </div>

                <div className=" font-bold capitalize text-sm text-gray-800  my-1">
                  Rs.{val.price}
                </div>
              </div>
              <div
                className="  text-gray-500  capitalize font-medium text-base"
                key={i}
              >
                {val.title}
              </div>
              <div className="font-bold capitalize text-xs text-gray-400  my-1">
                {val?.service.map((vals, index) => {
                  return <div>{vals.service_id}</div>;
                })}{" "}
                Services
              </div>
              <div className="font-medium capitalize text-xs text-gray-400  my-1">
                {new Date(val.date).toDateString()}
              </div>
              <div className="font-medium capitalize text-xs text-gray-400  my-1">
                {new Date(val.createdAt).toDateString()}
              </div>
              <div className="  border-b border-gray-200 my-2.5 "></div>
              <div className="flex justify-between">
                <div className="font-medium capitalize flex gap-1.5 items-center text-xs text-gray-500  my-1">
                  <div
                    className={`w-2 h-2 rounded-full ${
                      val.status === "pending"
                        ? "bg-orange-400"
                        : val.status === "accepted"
                        ? "bg-green-400"
                        : val.status === "rejected"
                        ? "bg-red-600"
                        : "bg-gray-400"
                    }`}
                  ></div>
                  <div>{val.status}</div>
                </div>
                <div className="border hover:border-gray-100  hvr-sweep-to-right font-medium capitalize text-xs text-gray-900  my-1">
                  <button className=" flex gap-2 items-center px-2 capitalize     hover:text-white  py-1.5">
                    view details
                    <IoIosArrowForward />
                  </button>
                </div>
              </div>
            </div>
          ) : active === "all" ? (
            <div className="bg-white rounded-md  my-4  px-5 py-2" key={i}>
              <div className="flex justify-between">
                <div className="  text-yellow-500 font-bold text-lg" key={i}>
                  #{val.token}
                </div>

                <div className=" font-bold capitalize text-sm text-gray-800  my-1">
                  Rs.{val.price}
                </div>
              </div>
              <div
                className="  text-gray-500  capitalize font-medium text-base"
                key={i}
              >
                {val.title}
              </div>
              {/* <div className="font-bold capitalize text-xs text-gray-400  my-1">
                {val?.service.map((vals, index) => {
                  return <div>{vals.service_id}</div>;
                })}{" "}
              </div> */}

              <div className="font-medium capitalize text-xs text-gray-400  my-1">
                <span className="text-green-500">
                  {" "}
                  appointment booked Date:
                </span>{" "}
                {new Date(val.date).toDateString()}
              </div>
              <div className="font-medium capitalize text-xs text-gray-400  my-1">
                <span className="text-yellow-500">
                  appointment created date:{" "}
                </span>{" "}
                {new Date(val.createdAt).toDateString()}
              </div>
              <div className="  border-b border-gray-200 my-2.5 "></div>
              <div className="flex justify-between">
                <div className="font-medium capitalize flex gap-1.5 items-center text-xs text-gray-500  my-1">
                  <div
                    className={`w-2 h-2 rounded-full ${
                      val.status === "pending"
                        ? "bg-orange-400"
                        : val.status === "accepted"
                        ? "bg-green-400"
                        : val.status === "rejected"
                        ? "bg-red-600"
                        : "bg-gray-400"
                    }`}
                  ></div>
                  <div>{val.status}</div>
                </div>
                <div className="border hover:border-gray-100  hvr-sweep-to-right font-medium capitalize text-xs text-gray-900  my-1">
                  <button className=" flex gap-2 items-center px-2 capitalize     hover:text-white  py-1.5">
                    view details
                    <IoIosArrowForward />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ""
          );
        })}
      </div>
    </div>
  );
}

export default BookingDatas;
